import React, { useState } from "react";
import Button from "../../assets/buttons/btnPrimary"
import ImgBanner from "./image/1440_hero.png"
import {Link} from "react-router-dom"
import "./banner.css";

const Banner = () => {
  
  return (
    <>
      <div className="bannerContainer">
        <div className="bannerImgContainer">
            <img src={ImgBanner} alt="" />
        </div>
       <div className="bannerColumn">
       <div className="bannerTextContainer">
            <p className="bannerText">Boost your business with</p>
            <h1 className="bannerTitle">Ding´s Group Argentina</h1>
            <p className="bannerTextTwo">Consultancy combines local experience and international network to ensure professional</p>
        </div>
        <Link to="mailto:bocabeijing@qq.com">   <Button styleClass="btnPrimary" value="CONTACT US"/> </Link>
       </div>

      </div>
    </>
  );
};

export default Banner;
